__turbopack_context__.v({
  "actionButton": "wZx9Ca_actionButton",
  "actions": "wZx9Ca_actions",
  "addEmailError": "wZx9Ca_addEmailError",
  "addEmailInput": "wZx9Ca_addEmailInput",
  "addEmailRow": "wZx9Ca_addEmailRow",
  "closeButton": "wZx9Ca_closeButton",
  "desc": "wZx9Ca_desc",
  "fields": "wZx9Ca_fields",
  "footerCheck": "wZx9Ca_footerCheck",
  "form": "wZx9Ca_form",
  "header": "wZx9Ca_header",
  "headerSent": "wZx9Ca_headerSent",
  "headerText": "wZx9Ca_headerText",
  "iconWrapper": "wZx9Ca_iconWrapper",
  "modal": "wZx9Ca_modal",
  "modalSent": "wZx9Ca_modalSent",
  "outsideFields": "wZx9Ca_outsideFields",
  "outsideHeader": "wZx9Ca_outsideHeader",
  "privacyNote": "wZx9Ca_privacyNote",
  "recipientsBlock": "wZx9Ca_recipientsBlock",
  "resetLink": "wZx9Ca_resetLink",
  "teamReferDestination": "wZx9Ca_teamReferDestination",
  "templateBlock": "wZx9Ca_templateBlock",
  "templateBlockIdle": "wZx9Ca_templateBlockIdle",
  "templateControl": "wZx9Ca_templateControl",
  "templateLabel": "wZx9Ca_templateLabel",
  "templateLabelRow": "wZx9Ca_templateLabelRow",
  "title": "wZx9Ca_title",
});
